export default {
      id: "close_error-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "sprite.svg#close_error-usage",
      toString: function () {
        return this.url;
      }
    }